// Mock data for Corporate Marking website

export const testimonials = [
  {
    id: 1,
    name: "Sarah Mitchell",
    role: "E-commerce Business Owner",
    content: "Corporate Marking made trademark registration seamless. Their team guided us through every step, and we got our trademark approved without any hassles. Highly professional service!",
    rating: 5
  },
  {
    id: 2,
    name: "James Rodriguez",
    role: "Tech Startup Founder",
    content: "I was worried about the complexity of trademark registration, but Corporate Marking handled everything efficiently. The comprehensive search they provided gave me peace of mind.",
    rating: 5
  },
  {
    id: 3,
    name: "Emily Chen",
    role: "Fashion Designer",
    content: "Outstanding service! They protected my brand identity quickly and professionally. The platinum package was worth every penny. I recommend them to all creative entrepreneurs.",
    rating: 5
  },
  {
    id: 4,
    name: "Michael Thompson",
    role: "Restaurant Chain Owner",
    content: "After expanding to multiple locations, protecting our brand became crucial. Corporate Marking delivered exceptional service with their trademark monitoring and support.",
    rating: 5
  },
  {
    id: 5,
    name: "Lisa Anderson",
    role: "Author & Publisher",
    content: "The copyright registration process was smooth and stress-free. Their team is knowledgeable, responsive, and truly cares about protecting your intellectual property.",
    rating: 5
  },
  {
    id: 6,
    name: "David Patel",
    role: "Software Company CEO",
    content: "Protecting our software brand was essential before launch. Corporate Marking's expertise in tech trademarks was invaluable. Fast, efficient, and professional throughout the entire process.",
    rating: 5
  },
  {
    id: 7,
    name: "Jennifer Williams",
    role: "Beauty Products Entrepreneur",
    content: "From initial consultation to final approval, the team was amazing! They explained everything clearly and kept me updated at every stage. Couldn't ask for better service.",
    rating: 5
  },
  {
    id: 8,
    name: "Robert Kim",
    role: "Consulting Firm Owner",
    content: "The comprehensive trademark search saved us from a costly mistake. Corporate Marking identified potential conflicts we hadn't considered. Their attention to detail is exceptional.",
    rating: 5
  },
  {
    id: 9,
    name: "Amanda Foster",
    role: "Online Retail Entrepreneur",
    content: "Amazon Brand Registry was confusing until I worked with Corporate Marking. They handled everything from trademark registration to brand registry enrollment. Highly recommend!",
    rating: 5
  },
  {
    id: 10,
    name: "Carlos Martinez",
    role: "Food & Beverage Brand Owner",
    content: "Exceptional value for money! The deluxe package gave us complete peace of mind with trademark monitoring and dedicated support. Best investment for our brand protection.",
    rating: 5
  },
  {
    id: 11,
    name: "Nicole Johnson",
    role: "Fitness Brand Founder",
    content: "Their team made the complex trademark process simple and stress-free. Quick responses, expert guidance, and successful registration. Five stars all the way!",
    rating: 5
  },
  {
    id: 12,
    name: "Thomas Wright",
    role: "Marketing Agency Owner",
    content: "Working with Corporate Marking was a game-changer for our agency. They protected our brand name and logo efficiently. Professional, knowledgeable, and results-driven team.",
    rating: 5
  }
];

export const processSteps = [
  {
    id: 1,
    title: "Consultation & Search",
    description: "We begin with a thorough consultation to understand your brand, followed by a comprehensive trademark search to ensure your mark is available and registrable.",
    icon: "Search"
  },
  {
    id: 2,
    title: "Filing & Documentation",
    description: "Our experts prepare and file all necessary documentation with the USPTO, ensuring accuracy and compliance with federal trademark regulations.",
    icon: "FileText"
  },
  {
    id: 3,
    title: "Monitoring & Protection",
    description: "After approval, we provide ongoing trademark monitoring and support to protect your brand from infringement and maintain your trademark rights.",
    icon: "Shield"
  }
];

export const pricingPlans = [
  {
    id: 1,
    name: "Essentials",
    price: "45",
    recommended: false,
    features: [
      "Case Review",
      "Case Filing",
      "Basic Search",
      "State E-Filing",
      "Trademark Secured"
    ],
    note: "Govt. filing fee not included"
  },
  {
    id: 2,
    name: "Enhanced",
    price: "149",
    recommended: false,
    features: [
      "Case Review",
      "Case Filing",
      "Direct Hit Search",
      "Trademark Alert",
      "Trademark Secured",
      "High Satisfaction Rate",
      "Refusal Risk Meter"
    ],
    note: "Govt. filing fee not included"
  },
  {
    id: 3,
    name: "Deluxe",
    price: "299",
    recommended: true,
    features: [
      "Case Review",
      "Case Filing",
      "Direct Hit Search",
      "Trademark Alert",
      "Trademark Secured",
      "High Satisfaction Rate",
      "Refusal Risk Meter",
      "Trademark Monitoring",
      "Complete Documentation",
      "Digital File",
      "Dedicated Case Manager"
    ],
    note: "Govt. filing fee not included"
  },
  {
    id: 4,
    name: "Platinum",
    price: "349",
    recommended: false,
    features: [
      "Case Review",
      "Case Filing",
      "Direct Hit Search",
      "Trademark Alert",
      "Trademark Secured",
      "High Satisfaction Rate",
      "Refusal Risk Meter",
      "Trademark Monitoring",
      "Complete Documentation",
      "Digital File",
      "Dedicated Case Manager",
      "High Approval Rate",
      "Comprehensive Search Report",
      "High Priority Service",
      "Cease & Desist Letter"
    ],
    note: "Govt. filing fee not included"
  }
];

export const services = [
  {
    id: 1,
    title: "Trademark Registration",
    slug: "trademark-registration",
    shortDescription: "Secure your brand identity with federal trademark protection.",
    icon: "Award"
  },
  {
    id: 2,
    title: "Copyright Registration",
    slug: "copyright-registration",
    shortDescription: "Protect your original creative works and intellectual property.",
    icon: "Copyright"
  },
  {
    id: 3,
    title: "Trademark Comprehensive Search",
    slug: "trademark-search",
    shortDescription: "Thorough search to ensure your trademark is available.",
    icon: "Search"
  },
  {
    id: 4,
    title: "Company Formation",
    slug: "company-formation",
    shortDescription: "Establish your business entity with proper legal structure.",
    icon: "Building2"
  },
  {
    id: 5,
    title: "Amazon Brand Registry",
    slug: "amazon-brand-registry",
    shortDescription: "Protect and enhance your brand presence on Amazon.",
    icon: "Package"
  }
];

export const countryCodes = [
  { code: "+1", country: "USA/Canada" },
  { code: "+44", country: "UK" },
  { code: "+91", country: "India" },
  { code: "+61", country: "Australia" },
  { code: "+49", country: "Germany" },
  { code: "+33", country: "France" },
  { code: "+86", country: "China" },
  { code: "+81", country: "Japan" },
  { code: "+55", country: "Brazil" },
  { code: "+52", country: "Mexico" }
];